import { ReactNode } from 'react';
import TechDocsLogo from '../../assets/techdocs-puzzle-logo.svg';
import { Page, Header } from '@backstage/core-components';
import { DefaultTechDocsHome } from '@backstage/plugin-techdocs';

const TechDocsPageWrapper = ({ children }: { children?: ReactNode }) => (
  <Page themeId="documentation">
    <Header
      pageTitleOverride="Puzzle Tech Docs"
      title={
        <img
          src={TechDocsLogo}
          alt="Puzzle Tech Docs"
          style={{ height: '40px', width: 'auto' }}
        />
      }
    />
    {children}
  </Page>
);

export const CustomTechDocsPage = () => {
  return <DefaultTechDocsHome PageWrapper={TechDocsPageWrapper} />;
};
